
export interface Bank {
    id: string;
    name: string;

}

export interface BankGroup {
    name: string;
    banks: Bank[];
    isOpen: boolean;
    id: number
}




/** list of bank groups */
export const INCOMEGROUPS: BankGroup[] = [
    {
        name: 'Earned',
        isOpen: false,
        id: 1,
        banks: [
            { name: 'Hourly wages', id: 'Hourly wages' },
            { name: 'Salaries', id: 'Salaries' },
            { name: 'Tips', id: 'Tips' },
            { name: 'Business sales', id: 'Business sales' },
            { name: 'Other', id: 'Earned_Other' }
        ]
    },
    {
        name: 'Profit',
        isOpen: false,
        id: 2,
        banks: [
            { name: 'Profit income', id: 'Profit income' },
            { name: 'Other', id: 'Profit_Other' },
        ]
    },
    {
        name: 'Interest',
        isOpen: false,
        id: 3,
        banks: [
            { name: 'Simple', id: 'Simple' },
            { name: 'Accrued', id: 'Accrued' },
            { name: 'Compounded', id: 'Compounded' },
            { name: 'Other', id: 'Interest_Other' },
        ]
    },
    {
        name: 'Dividend',
        isOpen: false,
        id: 4,
        banks: [
            { name: 'Cash', id: 'Cash' },
            { name: 'Stock', id: 'Stock' },
            { name: 'Property', id: 'Property' },
            { name: 'Liquidating', id: 'Liquidating' },
            { name: 'Other', id: 'Dividend_Other' },
        ]
    },
    {
        name: 'Rental',
        isOpen: false,
        id: 5,
        banks: [
            { name: 'Rental income', id: 'Rental income' },
            { name: 'Other', id: 'Rental_Other' }
        ]
    },
    {
        name: 'Capital Gains',
        isOpen: false,
        id: 6,
        banks: [
            { name: 'Short term', id: 'Short term' },
            { name: 'Long term', id: 'Long term' },
            { name: 'Other', id: 'Capital_Gains_Other' }
        ]
    },
    {
        name: 'Royalty',
        isOpen: false,
        id: 7,
        banks: [
            { name: 'Music', id: 'Music' },
            { name: 'Patent', id: 'Patent' },
            { name: 'Oil and gas', id: 'Oil and gas' },
            { name: 'Royalty Trust', id: 'Royalty Trust' },
            { name: 'TV & Film', id: 'TV & Film' },
            { name: 'Financing', id: 'Financing' },
            { name: 'Book', id: 'Book' },
            { name: 'Trademark', id: 'Trademark' },
            { name: 'Other', id: 'Royalty_Other' }
        ]
    },


];

/** list of bank groups */
export const EXPENSEGROUPS: BankGroup[] = [
    {
        name: 'Tax & Witholdings',
        isOpen: false,
        id: 1,
        banks: [
            { name: 'Income tax', id: 'Income tax' },
            { name: 'Social Security tax', id: 'Social Security tax' },
            { name: 'Medicare Witholding', id: 'Medicare Witholding' },
            { name: 'Capital Gains Tax', id: 'Capital Gains Tax' },
            { name: 'Other', id: 'TaxWitholdings_Other' }
        ]
    },
    {
        name: 'Home',
        isOpen: false,
        id: 2,
        banks: [
            { name: 'Mortgage', id: 'Mortgage' },
            { name: 'Property Tax', id: 'Property Tax' },
            { name: 'Insurance', id: 'Insurance' },
            { name: 'Bills & Utilities', id: 'Bills_Utilities' },
            { name: 'Furnishings', id: 'Furnishings' },
            { name: 'Improvements', id: 'Improvements' },
            { name: 'Maintenance', id: 'Maintenance' },
            { name: 'Supplies', id: 'Supplies' },
            { name: 'Inventory', id: 'Inventory' },
            { name: 'Other', id: 'Home_Other' }
        ]
    },
    {
        name: 'Motor Vehicles',
        isOpen: false,
        id: 3,
        banks: [
            { name: 'Auto Insurance', id: 'Auto_Insurance' },
            { name: 'Payment', id: 'Payment' },
            { name: 'Fuel', id: 'Fuel' },
            { name: 'Parking', id: 'Parking' },
            { name: 'Storage', id: 'Storage' },
            { name: 'Registration', id: 'Registration' },
            { name: 'Service', id: 'Service' },
            { name: 'Public Transit', id: 'Public_Transit' },
            { name: 'Other', id: 'Motor_Vehicles_Other' }
        ]
    },
    {
        name: 'Food & Dining',
        isOpen: false,
        id: 4,
        banks: [
            { name: 'Groceries', id: 'Groceries' },
            { name: 'Dining Out', id: 'Dining Out' },
            { name: 'Other', id: 'Food_Dining_Other' }
        ]
    },
    {
        name: 'Medical',
        isOpen: false,
        id: 5,
        banks: [
            { name: 'Doctor', id: 'Doctor' },
            { name: 'Health Insurance', id: 'Health_Insurance' },
            { name: 'Pharmacy', id: 'Pharmacy' },
            { name: 'Other', id: 'Medical_Other' },
        ]
    },
    {
        name: 'Insurance Premiums',
        isOpen: false,
        id: 6,
        banks: [
            { name: 'Life', id: 'Life' },
            { name: 'Disability', id: 'Disability' },
            { name: 'Long Term Care', id: 'Long_Term_Care' },
            { name: 'Umbrella', id: 'Umbrella' },
            { name: 'Other', id: 'Insurance_Premiums_Other' }
        ]
    },
    {
        name: 'Financial',
        isOpen: false,
        id: 7,
        banks: [
            { name: 'Bank Fees', id: 'Bank Fees' },
            { name: 'Loan & Interest Payments', id: 'Loan & Interest Payments' },
            { name: 'Professional Fees', id: 'Professional Fees' },
            { name: 'Other', id: 'Financial_Other' }
        ]
    },
    {
        name: 'Business',
        isOpen: false,
        id: 8,
        banks: [
            { name: 'General Expenses', id: 'General Expenses' },
            { name: 'Insurance', id: 'Insurance' }
        ]
    },
    {
        name: 'Education',
        isOpen: false,
        id: 9,
        banks: [
            { name: 'Tuition', id: 'Tuition' },
            { name: 'Other', id: 'Education_Other' }
        ]
    },
    {
        name: 'Discretionary',
        isOpen: false,
        id: 10,
        banks: [
            { name: 'Entertainment', id: 'Entertainment' },
            { name: 'Clothing', id: 'Clothing' },
            { name: 'Travel', id: 'Travel' },
            { name: 'Personal Care', id: 'Personal Care' },
            { name: 'Gym', id: 'Gym' },
            { name: 'Pets', id: 'Pets' },
            { name: 'Other', id: 'Discretionary_Other' }
        ]
    },
    {
        name: 'Giving & Saving',
        isOpen: false,
        id: 11,
        banks: [
            { name: 'Charitable Donations', id: 'Charitable Donations' },
            { name: 'Gifts', id: 'Gifts' },
            { name: 'Retirement Savings', id: 'Retirement_Savings' },
            { name: 'Education Savings', id: 'Education Savings' },
            { name: 'Investments', id: 'Investments' },
            { name: 'Other', id: 'Giving_Saving_Other' }
        ]
    },

];
export const VALUEGROUPS: BankGroup[] = [
    {
        name: 'Cash or Cash Equivalent',
        isOpen: false,
        id: 1,
        banks: [
            { name: 'Cash on hand', id: 'Cash on hand' },
            { name: 'Checking account', id: 'Checking account' },
            { name: 'Savings account', id: 'Savings account' },
            { name: 'Money market account', id: 'Money market account' },
            { name: 'Certificate of deposit', id: 'Certificate of deposit' },
            { name: 'Other', id: 'TaxWitholdings_Other' }
        ]
    },
    {
        name: 'Brokerage Account',
        isOpen: false,
        id: 2,
        banks: [
            { name: 'Stocks', id: 'Stocks' },
            { name: 'Mutual funds', id: 'Mutual funds' },
            { name: 'Municipal bonds', id: 'Municipal bonds' },
            { name: 'Government bonds', id: 'Government bonds' },
            { name: 'Corporate bonds', id: 'Corporate bonds' },
            { name: 'Other', id: 'Brokerage Account_Other' }
        ]
    },
    {
        name: 'Retirement Account',
        isOpen: false,
        id: 3,
        banks: [
            { name: '401(k)', id: '401(k)' },
            { name: '403(b)', id: '403(b)' },
            { name: '457', id: '457' },
            { name: 'Roth IRA', id: 'Roth IRA' },
            { name: 'Traditional IRA', id: 'Traditional IRA' },
            { name: 'Profit Sharing', id: 'Profit Sharing' },
            { name: 'Pension', id: 'Pension' }
        ]
    },
    {
        name: 'Properties',
        isOpen: false,
        id: 4,
        banks: [
            { name: 'Primary residence', id: 'Primary residence' },
            { name: 'Other residence', id: 'Other residence' },
            { name: 'Rental property', id: 'Rental property' },
            { name: 'Investment property', id: 'Investment property' }
        ]
    },
    {
        name: 'Motor Vehicles',
        isOpen: false,
        id: 5,
        banks: [
            { name: 'Automobile', id: 'Automobile' },
            { name: 'Motorcycle', id: 'Motorcycle' },
            { name: 'Boat', id: 'Boat' },
            { name: 'Recreational', id: 'Recreational' },
            { name: 'Aircraft', id: 'Aircraft' },
            { name: 'Heavy machinery', id: 'Heavy machinery' },
            { name: 'Other', id: 'Motor_Vehicles_Other' },
        ]
    },
    {
        name: 'Collectibles',
        isOpen: false,
        id: 6,
        banks: [
            { name: 'jewellery', id: 'jewellery' },
            { name: 'Antiques', id: 'Antiques' },
            { name: 'Firearms', id: 'Firearms' },
            { name: 'Other', id: 'Collectibles_Other' }
        ]
    },
    {
        name: 'Other',
        isOpen: false,
        id: 7,
        banks: [
            { name: 'Personal loans', id: 'Personal loans' },
            { name: 'Insurance value', id: 'Insurance value' },
            { name: 'Furnishings', id: 'Furnishings' },
            { name: 'Other', id: 'Other_Other' }
        ]
    },


];
export const LIABILITYGROUPS: BankGroup[] = [
    {
        name: 'Short Term Debt',
        isOpen: false,
        id: 1,
        banks: [
            { name: 'Credit card', id: 'Credit card' },
            { name: 'Personal loans', id: 'Personal loans' },
            { name: 'Line of credit', id: 'Line of credit' },
            { name: 'Other', id: 'Short_Term_Debt_Other' }
        ]
    },
    {
        name: 'Long Term Debt',
        isOpen: false,
        id: 2,
        banks: [
            { name: 'Primary residence', id: 'Primary residence' },
            { name: 'Other residence', id: 'Other residence' },
            { name: 'Rental property', id: 'Rental property' },
            { name: 'Investment property', id: 'Investment property' },
            { name: 'Motor Vehicle', id: 'Motor Vehicle' },
            { name: 'Student Loan', id: 'Student Loan' },
            { name: 'Other Loan', id: 'Other Loan' },
            { name: 'Business loan', id: 'Business loan' },
            { name: 'Other', id: 'Long_Term_DebtAccount_Other' }
        ]
    },
    {
        name: 'Other',
        isOpen: false,
        id: 3,
        banks: [
            { name: 'Commitments', id: 'Commitments' },
            { name: 'Other', id: 'other_other' }
        ]
    }

];

export const TRANSACTIONGROUPS: BankGroup[] = [
    {
        name: 'Auto & Transport',
        isOpen: false,
        id: 1,
        banks: [
            { name: 'Auto Insurance', id: 'Auto Insurance' },
            { name: 'Auto Payment', id: 'Auto Payment' },
            { name: 'Gas', id: 'Gas' },
            { name: 'Parking', id: 'Parking' },
            { name: 'Public Transportation', id: 'Public Transportation' },
            { name: 'Service & Parts', id: 'Service & Parts' }
        ]
    },
    {
        name: 'Bills & Utilities',
        isOpen: false,
        id: 2,
        banks: [
            { name: 'Domain Names', id: 'Domain Names' },
            { name: 'Fraud Protection', id: 'Fraud Protection' },
            { name: 'Home Phone', id: 'Home Phone' },
            { name: 'Hosting', id: 'Hosting' },
            { name: 'Internet', id: 'Internet' },
            { name: 'Mobile Phone', id: 'Mobile Phone' },
            { name: 'Television', id: 'Television' },
            { name: 'Utilities', id: 'Utilities' },
        ]
    },
    {
        name: 'Business Services',
        isOpen: false,
        id: 3,
        banks: [
            { name: 'Advertising', id: 'Advertising' },
            { name: 'Legal', id: 'Legal' },
            { name: 'Office Supplies', id: 'Office Supplies' },
            { name: 'Printing', id: 'Printing' },
            { name: 'Shipping', id: 'Shipping' }
        ]
    },
    {
        name: 'Education',
        isOpen: false,
        id: 4,
        banks: [
            { name: 'Books & Supplies', id: 'Books & Supplies' },
            { name: 'Student Loan', id: 'Student Loan' },
            { name: 'Tuition', id: 'Tuition' }
        ]
    },
    {
        name: 'Entertainment',
        isOpen: false,
        id: 5,
        banks: [
            { name: 'Amusement', id: 'Amusement' },
            { name: 'Arts', id: 'Arts' },
            { name: 'Movies & DVDs', id: 'Movies & DVDs' },
            { name: 'Music', id: 'Music' },
            { name: 'Newspapers & Magazines', id: 'Newspapers & Magazines' }
        ]
    },
    {
        name: 'Fees & Charges',
        isOpen: false,
        id: 6,
        banks: [
            { name: 'ATM Fee', id: 'ATM Fee' },
            { name: 'Banking Fee', id: 'Banking Fee' },
            { name: 'Finance Charge', id: 'Finance Charge' },
            { name: 'Late Fee', id: 'Late Fee' },
            { name: 'Service Fee', id: 'Service Fee' },
            { name: 'Trade Commissions', id: 'Trade Commissions' },
        ]
    },
    {
        name: 'Financial',
        isOpen: false,
        id: 7,
        banks: [
            { name: 'Financial Advisor', id: 'Financial Advisor' },
            { name: 'Life Insurance', id: 'Life Insurance' }
        ]
    },
    {
        name: 'Food & Dining',
        isOpen: false,
        id: 8,
        banks: [
            { name: 'Alcohol & Bars', id: 'Alcohol & Bars' },
            { name: 'Coffee Shops', id: 'Coffee Shops' },
            { name: 'Fast Food', id: 'Fast Food' },
            { name: 'Groceries', id: 'Groceries' },
            { name: 'Restaurants', id: 'Restaurants' },
        ]
    },
    {
        name: 'Gifts & Donations',
        isOpen: false,
        id: 9,
        banks: [
            { name: 'Charity', id: 'Charity' },
            { name: 'Gift', id: 'Gift' }
        ]
    },
    {
        name: 'Health & Fitness',
        isOpen: false,
        id: 10,
        banks: [
            { name: 'Dentist', id: 'Dentist' },
            { name: 'Doctor', id: 'Doctor' },
            { name: 'Eyecare', id: 'Eyecare' },
            { name: 'Gym', id: 'Gym' },
            { name: 'Health Insurance', id: 'Health Insurance' },
            { name: 'Pharmacy', id: 'Pharmacy' },
            { name: 'Sports', id: 'Sports' }
        ]
    },
    {
        name: 'Home',
        isOpen: false,
        id: 11,
        banks: [
            { name: 'Furnishings', id: 'Furnishings' },
            { name: 'Home Improvement', id: 'Home Improvement' },
            { name: 'Home Insurance', id: 'Home Insurance' },
            { name: 'Home Services', id: 'Home Services' },
            { name: 'Home Supplies', id: 'Home Supplies' },
            { name: 'Lawn & Garden', id: 'Lawn & Garden' },
            { name: 'Mortgage & Rent', id: 'Mortgage & Rent' }
        ]
    },
    {
        name: 'Income',
        isOpen: false,
        id: 12,
        banks: [
            { name: 'Bonus', id: 'Bonus' },
            { name: 'Interest Income', id: 'Interest Income' },
            { name: 'Paycheck', id: 'Paycheck' },
            { name: 'Reimbursement', id: 'Reimbursement' },
            { name: 'Rental Income', id: 'Rental Income' },
            { name: 'Returned Purchase', id: 'Returned Purchase' }
        ]
    },
    {
        name: 'Investments',
        isOpen: false,
        id: 13,
        banks: [
            { name: 'Buy', id: 'Buy' },
            { name: 'Deposit', id: 'Deposit' },
            { name: 'Dividend & Cap Gains', id: 'Dividend & Cap Gains' },
            { name: 'Sell', id: 'Sell' },
            { name: 'Withdrawal', id: 'Withdrawal' }
        ]
    },
    {
        name: 'Kids',
        isOpen: false,
        id: 14,
        banks: [
            { name: 'Allowance', id: 'Allowance' },
            { name: 'Baby Supplies', id: 'Baby Supplies' },
            { name: 'Babysitter & Daycare', id: 'Babysitter & Daycare' },
            { name: 'Child Support', id: 'Child Support' },
            { name: 'Kids Activities', id: 'Kids Activities' },
            { name: 'Toys', id: 'Toys' }
        ]
    },
    {
        name: 'Personal Care',
        isOpen: false,
        id: 15,
        banks: [
            { name: 'Hair', id: 'Hair' },
            { name: 'Laundry', id: 'Laundry' },
            { name: 'Spa & Massage', id: 'Spa & Massage' }
        ]
    },
    {
        name: 'Pets',
        isOpen: false,
        id: 16,
        banks: [
            { name: 'Pet Food & Supplies', id: 'Pet Food & Supplies' },
            { name: 'Pet Grooming', id: 'Pet Grooming' },
            { name: 'Veterinary', id: 'Veterinary' }
        ]
    },
    {
        name: 'Shopping',
        isOpen: false,
        id: 17,
        banks: [
            { name: 'Books', id: 'Books' },
            { name: 'Clothing', id: 'Clothing' },
            { name: 'Hobbies', id: 'Hobbies' },
            { name: 'Sporting Goods', id: 'Sporting Goods' }
        ]
    },
    {
        name: 'Taxes',
        isOpen: false,
        id: 18,
        banks: [
            { name: 'Federal Tax', id: 'Federal Tax' },
            { name: 'Local Tax', id: 'Local Tax' },
            { name: 'Property Tax', id: 'Property Tax' },
            { name: 'Sales Tax', id: 'Sales Tax' },
            { name: 'State Tax', id: 'State Tax' }
        ]
    },
    {
        name: 'Transfer',
        isOpen: false,
        id: 19,
        banks: [
            { name: 'Credit Card Payment', id: 'Credit Card Payment' },
            { name: 'Transfer for Cash Spending', id: 'Transfer for Cash Spending' },
            { name: 'Mortgage Payment', id: 'Mortgage Payment' }
        ]
    },
    {
        name: 'Travel',
        isOpen: false,
        id: 20,
        banks: [
            { name: 'Air Travel', id: 'Air Travel' },
            { name: 'Hotel', id: 'Hotel' },
            { name: 'Rental Car & Taxi', id: 'Rental Car & Taxi' },
            { name: 'Vacation', id: 'Vacation' }
        ]
    },
    {
        name: 'Uncategorized',
        isOpen: false,
        id: 21,
        banks: [
            { name: 'Cash', id: 'Cash' },
            { name: 'Check', id: 'Check' }
        ]
    },

];
